import React from "react";
import { Box, styled } from "@mui/material";
import ConfirmationDialog from "./ConfirmationDialog";
import useConfirmationDialog from "../../hooks/useConfirmationDialog";

const StyledBox = styled(Box)`
  width: fit-content;
  cursor: pointer;
`;

const ConfirmationContainer = ({
  dialogTitle,
  dialogMessage,
  onConfirmed,
  children,
}) => {
  const confirmationDialog = useConfirmationDialog();

  const handleConfirmed = () => {
    onConfirmed();
    confirmationDialog.close();
  };

  return (
    <>
      <StyledBox onClick={() => confirmationDialog.open()}>
        {children}
      </StyledBox>
      {confirmationDialog.dialogOpen && <ConfirmationDialog
        title={dialogTitle}
        message={dialogMessage}
        open={confirmationDialog.dialogOpen}
        onCanceled={() => confirmationDialog.close()}
        onConfirmed={handleConfirmed}
      />}
    </>
  );
};

export default ConfirmationContainer;